<template>
  <div>
    <div v-show="listing" class="app-content content ">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header row">
          <div class="content-header-left col-md-9 col-12 mb-2">
            <Breadcrumb
                name="Refund Request"
                bc1="App"
                bc2="Refund Refund"
                bc3="List"
            ></Breadcrumb>
          </div>
        </div>
        <!-- initialte modal -->
        <div
            class="modal show fade modal text-left "
            style="display: block;"
            v-if="initiateRefundModal"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" style="text-transform:capitalize;">
                  Initiate Request
                </h4>
                <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="(initiateRefundModal = false), (comment = ''), (directCredit=0)"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">

                  <b-form-group label="Comment" label-for="Comment">
                    <b-form-textarea
                        id="textarea-default"
                        placeholder="Comment..."
                        v-model="comment"
                    ></b-form-textarea>
                  </b-form-group>
                  <div class="row">
                    <div class="col-12">
                      <div class="custom-control custom-control-primary custom-checkbox">
                        <input :true-value="1" :false-value="0" name="directCredit" type="checkbox" v-model="directCredit"
                               class="custom-control-input" id="colorCheck1"/>
                        <label class="custom-control-label " style="width: max-content" for="colorCheck1">Initiate As Direct Credit</label>
                      </div>
                    </div>

                  </div>

              </div>
              <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="(initiateRefundModal = false), (comment = ''), (directCredit=0)"
                >
                  Cancel
                </button>
                <button
                    type="button"
                    class="btn btn-primary d-flex mr-1"
                    @click="initiateRefundRequest()"
                    :disabled="loading"
                >
                  <Loader :loading="loading" :size="size"></Loader>
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="initiateRefundModal" class="modal-backdrop fade show"></div>
        <!-- initiate modal ends -->
        <!-- Process modal starts-->
        <div
            class="modal show fade modal text-left "
            style="display: block;"
            v-if="processRefundModal"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" style="text-transform:capitalize;">
                  Process Refund
                </h4>
                <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="
                  (processRefundModal = false), (comment = ''), (reference = '')
                "
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">

                <b-form>
                  <div class="col-12">

                    <div class="form-group row">
                      <div class="col-sm-3 col-form-label">
                        <label >Reference</label>
                      </div>
                      <div class="col-sm-9">
                        <div class="input-group">
                          <input
                              type="text"
                              v-model="reference"
                              class="form-control"

                              name="reference"
                              placeholder="Reference"
                          />
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group row">
                      <div class="col-sm-3 col-form-label">
                        <label>Comment</label>
                      </div>
                      <div class="col-sm-9">
                        <div class="input-group">
                          <b-form-textarea
                              id="textarea-default"
                              placeholder="Comment..."
                              v-model="comment"
                          ></b-form-textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-form>
              </div>
              <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="
                  (processRefundModal = false), (comment = ''), (reference = '')
                "
                >
                  Cancel
                </button>
                <button
                    type="submit"
                    class="btn btn-primary d-flex mr-1"
                    :disabled="loading"
                    @click="ProcessRefundRequest()"
                >
                  <Loader :loading="loading" :size="size"></Loader>
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="processRefundModal" class="modal-backdrop fade show"></div>
        <!-- Process modal ends -->
        <!-- Reject modal starts-->
        <div
            class="modal show fade modal text-left "
            style="display: block;"
            v-if="rejectRefundModal"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" style="text-transform:capitalize;">
                  Reject Refund
                </h4>
                <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="(rejectRefundModal = false), (comment = '')"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <b-form>
                  <b-form-group label="Comment" label-for="Comment">
                    <b-form-textarea
                        id="textarea-default"
                        placeholder="Comment..."
                        v-model="comment"
                    ></b-form-textarea>
                  </b-form-group>
                </b-form>
              </div>
              <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="(rejectRefundModal = false), (comment = '')"
                >
                  Cancel
                </button>
                <button
                    type="button"
                    class="btn btn-primary d-flex mr-1"
                    @click="rejectRefundRequest()"
                    :disabled="loading"
                >
                  <Loader :loading="loading" :size="size"></Loader>
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="rejectRefundModal" class="modal-backdrop fade show"></div>
        <!-- Reject modal ends -->
        <UserModal
            :userData="userData"
            :show="showUserModal"
            @hide="showUserModal = false"
        ></UserModal>
        <DetailsModal
            :description="currentRowDescription"
            :data="detailsData"
            :show="showDetailsModal"
            @hide="showDetailsModal = false"
        ></DetailsModal>
        <TransactionModal
            :transactionData="transactionData"
            :show="showTransactionModal"
            @hide="showTransactionModal = false"
        ></TransactionModal>
        <ExchangeDetailModal
            :exchangeData="exchangeData"
            :show="showExchangeData"
            @hide="showExchangeData = false"
        ></ExchangeDetailModal>
        <div class="content-body">
          <div class="card">
            <h5 class="card-header">Search Filter</h5>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-4 user_plan">
                <SelectOptions
                    label=""
                    selectAppend="currency"
                    labelValue="code"
                    :filter="{ flag: 'active' }"
                    :modelValue.sync="selectedAccount"
                    :url="showSelectAccountOption"
                />
              </div>
              <div class="col-md-4 user_status">
                <input class="form-control" @keyup.enter="onSubmitFilters" type="text" v-model="search" placeholder="Search here..."/>
              </div>
              <div class="col-md-4 user_status">
                <select class="form-control"  v-model="recordStatus">
                  <option :value="null">Select Status</option>
                  <option
                      v-for="(item, index) in recordStatusOptions"
                      :key="index"
                      :value="item.id"
                  >{{ item.value }}</option
                  >
                </select>
              </div>


            </div>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-6 mb-1 user_plan">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div >
                      <label>Select Store</label>
                      <SearchSelect
                          v-model="selectedStore"
                          url="v1/get-store"
                          :filterParams="{ status: 1 }"
                          :customLabelFn="customStoreNameForMultiselect"
                          placeholder="Search Store..."
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-1 user_plan">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="input-group">
                      <label>Select Terminal</label>
                      <multiselect
                          v-model="selectedTerminal"
                          :options="terminalData"
                          label="label"
                          track-by="id"
                          placeholder="Select Terminal"
                          :loading="terminalLoader"
                          variant="primary"
                          :custom-label="customStoreNameForMultiselect"
                      ></multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 user_plan">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="input-group">
                      <label>Select Channel</label>
                      <multiselect
                          v-model="selectedChannel"
                          :options="channelData"
                          label="label"
                          track-by="id"
                          placeholder="Select Channel"
                          :loading="channelLoader"
                          variant="primary"
                          :custom-label="customStoreNameForMultiselect"
                      ></multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-4 user_status">
                <SelectOptions
                    label=""
                    selectAppend="payment method"
                    labelValue="name"
                    :filter="{ flag: 'active' }"
                    :modelValue.sync="paymentMethodId"
                    url="v1/get-payment-method"
                />
              </div>
              <div class="col-md-4 user_status">
                <date-picker
                    class="w-100"
                    :disabledDate="disableFutureDates"
                    v-model="fromDate"
                    valueType="format"
                    :lang="lang"
                    name="fromDate"
                    placeholder="choose start date"
                ></date-picker>
              </div>
              <div class="col-md-4 user_status">
                <date-picker
                    class="w-100"
                    v-model="toDate"
                    :disabledDate="disableFutureDates"
                    valueType="format"
                    :lang="lang"
                    name="toDate"
                    placeholder="choose end date"
                ></date-picker>
              </div>
            </div>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-4 user_status">
                <button type="button" class="btn btn-primary" @click="onSubmitFilters" >Search</button>
                <button type="button" class="ml-1 btn btn-danger "  @click="clear">Clear</button>
              </div>

            </div>
          </div>
          <div class="card">

            <CommonTable
                v-if="renderComponent"
                :url="url"
                :tableHeaderValues="tableHeaderValues"
                :actions="actions"
                :deleteActions="deleteActions"
                :mutedData="mutedData"
                :storageKey="storageKey"
                :externalTotalRecord="externalTotalRecord"
                :exportData="exportData"
                :hidePdfExportButton="true"
                :show-per-page="true"
                :hideAllPerPage="true"
                :filteredData="filteredData"
            />
          </div>
        </div>
      </div>
    </div>
    <RefundGatewayDetails :rowData="rowData" v-if="!listing " @backFromDetailPage="listing = true" />
  </div>

</template>

<script>
import {CommandIcon} from "vue-feather-icons";
import UserModal from "@/components/common/modals/RefundRequestsModals/refundUserModal.vue";
import TransactionModal from "@/components/common/modals/RefundRequestsModals/refundTransactionModal.vue";
import DetailsModal from "@/components/common/modals/RefundRequestsModals/refundDetailsModal";
import RefundGatewayDetails from "@/pages/dashboard/refund-request/RefundGatewayDetails";
import ExchangeDetailModal from "@/pages/dashboard/transactions/ExchangeDetailModal";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import SearchSelect from "@/components/common/SearchSelect.vue";

export default {
  components: {
    SearchSelect,
    CommandIcon,
    UserModal,
    TransactionModal,
    DetailsModal,
    RefundGatewayDetails,
    ExchangeDetailModal,
    DatePicker
  },
  mounted() {
    this.showSelectAccountOption = 'v1/get-currency'
    localStorage.setItem("url", "v1/get-refund-request");
    this.checkDataInStore('v1/get-refund-request')
    if (
      typeof this.$route.params.update == "undefined" &&
      typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }

    if(typeof(this.propFilters) != 'undefined'){


      let filterData = {}

      if(this.propFilters.currentPage){
        filterData.page = this.propFilters.currentPage
      }

      if(this.propFilters.search){
        this.search = this.propFilters.search
        filterData.search = this.search
      }

      this.filteredData = filterData
    }
    // this.getStoreData()
  },
  data() {
    return {
      recordStatus: null,
      recordStatusOptions: [
        { id: 0, value: "Pending" },
        { id: 1, value: "Initiated" },
        { id: 2, value: "Processed" },
        { id: 3, value: "Canceled" },
        { id: 4, value: "Rejected" },
      ],
      exchangeData:{},
      search: '',
      showExchangeData:false,
      filteredData: {},
      currentPage: 1,
      listing:true,
      rowData:[],
      exportData: {
        cta: (exportType) => {
          let filterData = {
            exportAs: exportType,
            reportType: 'refunds',
          }


          if(this.selectedStore){
            filterData.storeId = this.selectedStore.id
          }
          if(this.selectedTerminal){
            filterData.terminalId = this.selectedTerminal.id
          }
          if(this.selectedChannel){
            filterData.channelId = this.selectedChannel.id
          }


          if(this.selectedAccount){
            filterData.currencyId = this.selectedAccount.id
          }
          if(this.paymentMethodId){
            filterData.paymentMethodId = this.paymentMethodId.id
          }
          if(this.search != ''){
            filterData.search = this.search
          }
          if(this.toDate){
            filterData.toDate = this.toDate
          }
          if(this.fromDate){
            filterData.fromDate = this.fromDate
          }

          if(this.recordStatus != null){
            filterData.status = this.recordStatus
          }





          this.downloadReport(filterData)
        }
      },
      url: "v1/get-refund-request",
      storageKey: "refundRequest",
      isDefault: false,
      showUserModal: false,
      userData: [],
      currentRowDescription: "",
      transactionData: [],
      showTransactionModal: false,
      initiateRefundModal: false,
      rejectRefundModal: false,
      processRefundModal: false,
      size: "10px",
      refundId: "",
      reference: "",
      comment: "",
      directCredit:0,
      initiateRefundIndex: "",
      loading: false,
      index: "",
      renderComponent: true,
      detailsData: [],
      showDetailsModal: false,
      tableHeaderValues: [
        {
          title: "Refund ID",
          valueKey: "uuid",
          html: true,
          alter: function (value, row) {
            var html = "";
            if (value) {
              html = `<span class="text-primary font-weight-bolder">${value}</span>`;
              if(row.direct_credit != 0){
                html = `
                <div class="row">
                <div class="col-12">
                <span class="text-primary font-weight-bolder ">${value}</span>
                </div>
                <p>
                <div class="badge badge-light-primary ml-1" style="margin-top: 0.3rem">Direct Credit</div></p></div>`
              }
              if (row.added_by && row.added_by_user) {
                if(row.added_by != row.user_id){
                  html = `
                <div class="row">
                <div class="col-12">
                <span class="text-primary font-weight-bolder ">${value}</span>
                </div><p><div class="badge badge-light-dark ml-1" style="margin-top: 0.3rem">${row.added_by_user.email+'/'+row.added_by_user.first_name+' '+row.added_by_user.last_name}</div></p></div>`

                  if(row.direct_credit != 0){
                    html = `
                    <div class="row">
                     <div class="col-12">
                    <span class="text-primary font-weight-bolder ">${value}</span>
                    </div><p><div class="badge badge-light-dark ml-1" style="margin-top: 0.3rem">${row.added_by_user.email+'/'+row.added_by_user.first_name+' '+row.added_by_user.last_name}</div></p>
                     <p>
                <div class="badge badge-light-primary ml-1" style="margin-top: 0.3rem">Direct Credit</div></p></div>`
                  }


                }
              }

            }

            return html;
          },
          cta: (row) => {
            if(row.uuid){
              this.copyText(row.uuid);
            }

          }
        },
        {
          title: 'Reference Id',
          valueKey: 'reference_id',
          html: true,
          alter: function(value) {
            var html=''
            if(value)
              html = `<span class="text-warning ">${value}</span>`
            else
              html = `<span class="text-dark ">N/A</span>`

            return  html


          },
          cta: (row) => {
            if(row.reference_id){
              this.copyText(row.reference_id);
            }

          }
        },
        {
          title: "Amount",
          valueKey: "amount",
          html: true,
          alter: (value, row) => {
            if (!value) {
              return "-";
            } else {
              return `<span style="" class=" font-weight-bolder text-dark">${this.modifyAmount(parseFloat(
                value / 100
              ).toFixed(this.amountDecimalPlaces))}</span>&nbsp<div class="badge badge-light-success">${row.refunded_transaction ? (row.refunded_transaction.sender_account ? row.refunded_transaction.sender_account.currency.code : '') : ''}</div>`;
            }
          }
        },
        {
          title: "Transaction Id",
          valueKey: "transaction_id",
          html: true,
          alter:  (value,row) => {
            var html = "";
            if (value) {
              html = `<span class="font-weight-bolder text-primary" style="cursor: pointer">${value}</span>`;
            } else {
              html = "-";
            }
            if(row.refunded_transaction){
              if(row.refunded_transaction.exchange_details){
                if(row.refunded_transaction == 4){
                  html = `
                <div class="row">
                    <div class="col-12 ">
                        <span class="font-weight-bolder text-primary" style="cursor: pointer">${value}</span>
                        <div class="badge badge-light-primary mt-1">${'exchange with '+ row.refunded_transaction.exchange_details.to_currency}</div>
                    </div>
                </div>
                `

                }else{
                  html = `
                <div class="row">
                    <div class="col-12 ">
                       <span style="cursor: pointer">${value}</span>
                        <div class="badge badge-light-primary mt-1">${'processed in '+ row.refunded_transaction.exchange_details.to_currency}</div>
                    </div>
                </div>
                `
                }
              }

            }else{
              html = `<div class="row">
                    <div class="col-12 ">
                                       <span style="cursor: pointer">${value}</span>

                    </div>
                </div>`
            }

            return html
          },
          cta: (row) => {
            this.copyText(row.transaction_id);
            this.$router.push({name: 'transactions-detail',params: {id:row.transaction_id}})
          }
        },
        {
          title: "Status",
          valueKey: "status_str",
          html: true,
          alter: (value,row) => {
            var html = "";
            if (value == 'Processed') {
              html = `<span class="badge-light-success badge">${value}</span>`;
            }else if(value == 'Iniated'){
              html = `<span class="badge-light-primary badge">Initiated</span>`;
            }
            else if(value == 'Pending'){
              html = `<span class="badge-light-warning badge">${value}</span>`;
            }else if(value == 'Rejected'){
              html = `<span class="badge-light-danger badge">${value}</span>`;
            }
            else{
              html = `<span class="badge-light-dark badge">${value}</span>`;
            }

            // if(value == 'Iniated'){
              html = `
                <div class="row">
                    <div class="col-12 ">
                       ${html}
                        <div class="badge badge-dark mt-1" style="cursor: pointer;">Show Gateway Details</div>
                    </div>
                </div>
                `

            // }

            return html;
          },
          cta: (row) => {
            // if(row.status_str == 'Iniated'){
              this.rowData = row
              this.listing = false
            // }
          }
        },
        {
          title: "Created Date / Time",
          titleHtml: `<span class="text-warning font-weight-bolder">
														(Showing In GMT)
													</span>`,
          valueKey: "created_at",
          html: true,
          alter: (value,row) => {
            var html='-'
            if(value)
              html = ` <div  class=" font-weight-bolder text-dark">${new Date(value).toISOString().slice(0, 16).replace('T', ' ')}</div>`



            return  html


          }
          //     alter: (value) => {
          //   // return this.customFormatDateTime(value)
          //       return new Date(value).toISOString().slice(0, 16).replace('T', ' ')
          // }
        },
        // {
        //   title: "Status",
        //   valueKey: "status",
        //   html: true,
        //   alter: function(value, row) {
        //     var html = "";
        //     if (value == 1) {
        //       html = `<span class="badge badge-pill badge-success badge-sm">Active</span>`;
        //     } else {
        //       html = `<span class="badge badge-pill badge-danger badge-sm">Inactive</span>`;
        //     }
        //
        //     if (row.is_default == 1) {
        //       this.isDefault = true;
        //       html += '<span class="badge badge-secondary ml-1">Default</span>';
        //     }
        //
        //     return html;
        //   }
        // }
      ],
      actions: [
        {
          title: "Details",
          class: "btn-info  mt-1",
          modalId: "v-b-modal.modal-primary",
          cta: (row, index) => {
            this.showDetailsModal = true;
            this.detailsData = [];
            this.currentRowDescription = row.description
            if (row.details) {
              this.detailsData = row.details;
            }
          }
        },
        {
          title: "User",
          class: "btn-primary  mt-1",
          modalId: "v-b-modal.modal-primary",
          cta: (row, index) => {
            this.showUserData(row, index);
          }
        },
        {
          title: "Transaction",
          class: "btn-primary mt-1",
          cta: (row, index) => {
            this.showTransactionData(row, index);
          }
        },
        {
          title: 'Exchange',
          class: "btn-primary mt-1  ml-sm-50",
          conditionalRendering: true,
          condition: (row)=>{
            if(row.refunded_transaction){
              if(row.refunded_transaction.exchange_details){
                return true
              }
            }
            return false
          },
          cta: (row) => {
            this.exchangeData = {}
            if(row.refunded_transaction.exchange_details){
              this.exchangeData = row.refunded_transaction
            }
            this.showExchangeData = true
          }
        },
        {
          title: "Process",
          conditionalRendering: true,
          condition: row => {
            if (row.status == 0 || row.status == 1) {
              return true;
            }
            return false;
          },
          class: "btn-success pill mt-1",
          cta: (row, index) => {
            this.processRefund(row, index);
          }
        },
        {
          title: "Initiate",
          conditionalRendering: true,
          condition: row => {
            if (row.status == 0 && row.direct_credit == 0) {
              return true;
            }
            return false;
          },
          class: "btn-warning pill mt-1",
          cta: (row, index) => {
            this.initiateRefund(row, index);
          }
        },
        {
          title: "Reject",
          conditionalRendering: true,
          condition: row => {
            if (row.status == 0 || row.status == 1) {
              return true;
            }
            return false;
          },
          class: "btn-danger pill mt-1",
          cta: (row, index) => {
            this.rejectRefund(row, index);
          }
        }
      ],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: "",
      fromDate: null,
      toDate: null,
      selectedAccount: null,
      paymentMethodId:null,
      showSelectAccountOption: '',
      showSelectTypesOption: '',
      transactionTypes: [],
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      selectedMerchant: null,
      selectedStore: null,
      selectedTerminal: null,
      selectedChannel: null,
      storeData: [],
      terminalData: [],
      channelData: [],
      terminalLoader:false,
      channelLoader:false,
    };
  },
  methods: {
    processRefund(row, index) {
      this.index = index;
      this.refundId = row.id;
      this.processRefundModal = true;
      this.initiateRefundIndex = index;
    },
    initiateRefund(row, index) {
      this.index = index;
      this.refundId = row.id;
      this.initiateRefundModal = true;
      this.initiateRefundIndex = index;
    },
    rejectRefund(row, index) {
      this.index = index;
      this.refundId = row.id;
      this.rejectRefundModal = true;
      this.initiateRefundIndex = index;
    },
    showUserData(row) {
      this.showUserModal = true;
      this.userData = [];
      if (row.user) {
        this.userData = row.user;
      }
    },
    showTransactionData(row) {
      this.showTransactionModal = true;
      if (row.refunded_transaction) {
        this.transactionData = row.refunded_transaction;
      }
    },
    initiateRefundRequest() {
      this.loading = true;
      let data = {
        refundId: this.refundId,
        comment: this.comment
      };
      if(this.directCredit){
        data.directCredit = this.directCredit
      }

      this.makeRequest("post", "v1/initiate-refund-request", data).then(
        callResponse => {
          if (!callResponse.error) {
            let code = callResponse.response.data.code;
            if (code == 200) {
              this.comment = "";
              this.directCredit = 0
              this.initiateRefundModal = false;
              this.loading = false;
              this.mutedData = {
                index: this.index,
                status_str: (typeof (callResponse.response.data.data.status_str) != 'undefined') ? callResponse.response.data.data.status_str : "Initiated",
                status: callResponse.response.data.data.status
                  ? callResponse.response.data.data.status
                  : 1
              };
            } else {
              this.initiateRefundModal = false;
              this.loading = false;
              this.directCredit = 0
              this.comment = "";
            }
          }
        }
      );
    },
    ProcessRefundRequest() {
      this.loading = true;
      let data = {
        refundId: this.refundId,
        comment: this.comment,
        reference: this.reference
      };
      this.makeRequest("post", "v1/process-refund-request", data).then(
        callResponse => {
          if (!callResponse.error) {
            let code = callResponse.response.data.code;
            if (code == 200) {
              this.comment = "";
              this.reference = "";
              this.processRefundModal = false;
              this.loading = false;
              this.mutedData = {
                index: this.index,
                status_str: (typeof (callResponse.response.data.data.status_str) != 'undefined') ? callResponse.response.data.data.status_str : "Processed",
                status: callResponse.response.data.data.status
                  ? callResponse.response.data.data.status
                  : 2
              };
            } else {
              this.processRefundModal = false;
              this.loading = false;
              this.comment = "";
              this.reference = "";
            }
          }
        }
      );
    },
    rejectRefundRequest() {
      this.loading = true;
      let data = {
        refundId: this.refundId,
        comment: this.comment
      };
      this.makeRequest("post", "v1/reject-refund-request", data).then(
        callResponse => {
          if (!callResponse.error) {
            let code = callResponse.response.data.code;
            if (code == 200) {
              this.comment = "";
              this.rejectRefundModal = false;
              this.loading = false;
              this.mutedData = {
                index: this.index,
                status_str: (typeof (callResponse.response.data.data.status_str) != 'undefined') ? callResponse.response.data.data.status_str : "Rejected",
                status: callResponse.response.data.data.status
                  ? callResponse.response.data.data.status
                  : 4
              };
            } else {
              this.rejectRefundModal = false;
              this.loading = false;
              this.comment = "";
            }
          }
        }
      );
    },
    onSubmitFilters() {

      let filterData = {}

      if(this.selectedStore){
        filterData.storeId = this.selectedStore.id
      }
      if(this.selectedTerminal){
        filterData.terminalId = this.selectedTerminal.id
      }
      if(this.selectedChannel){
        filterData.channelId = this.selectedChannel.id
      }


      if(this.selectedAccount){
        filterData.currencyId = this.selectedAccount.id
      }
      if(this.paymentMethodId){
        filterData.paymentMethodId = this.paymentMethodId.id
      }
      if(this.search != ''){
        filterData.search = this.search
      }
      if(this.toDate){
        filterData.toDate = this.toDate
      }
      if(this.fromDate){
        filterData.fromDate = this.fromDate
      }

      if(this.recordStatus != null){
        filterData.status = this.recordStatus
      }



      this.filteredData = filterData




    },
    clear(){

      this.selectedAccount = null
      this.paymentMethodId = null
      this.recordStatus = null
      this.toDate = null
      this.fromDate = null
      this.search = ''
      this.selectedStore = null
      this.selectedTerminal = null
      this.selectedChannel = null
      this.filteredData = {}

    },
    getStoreData() {
      this.makeRequest("post", "v1/get-store", {status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.storeData = responseData;
                }
                else{
                  this.storeData = []
                }
                // this.setSelectedStoreValue();
              }
            }
          }
      );
    },
    setSelectedStoreValue() {


      if (this.selectedStore == null && this.storeData.length > 0) {
        this.selectedStore = this.storeData[0];

      }
      else{
        this.selectedStore = null
      }
    },
    getTerminalData() {
      this.terminalLoader = true
      this.makeRequest("post", "v1/get-terminal", {storeId:this.selectedStore?this.selectedStore.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.terminalData = responseData;
                }
                else{
                  this.terminalData = []
                }
                // this.setSelectedTerminalValue();
              }
            }
            this.terminalLoader = false
          }
      );
    },
    setSelectedTerminalValue() {


      if (this.selectedTerminal == null && this.terminalData.length > 0) {
        this.selectedTerminal = this.terminalData[0];

      }
      else{
        this.selectedTerminal = null
      }
    },
    getChannelData() {
      this.channelLoader = true
      this.makeRequest("post", "v1/get-channel", {storeId:this.selectedStore?this.selectedStore.id:'',terminalId:this.selectedTerminal?this.selectedTerminal.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.channelData = responseData;
                }
                else{
                  this.channelData = []
                }
                // this.setSelectedChannelValue();
              }
            }
            this.channelLoader = false
          }
      );
    },
    setSelectedChannelValue() {
      if (this.selectedChannel == null && this.channelData.length > 0) {
        this.selectedChannel = this.channelData[0];

      }
      else{
        this.selectedChannel = null
      }
    },
    customStoreNameForMultiselect ({ name,code }) {
      return `${name}/${code}`
    },
  },
  watch: {
    selectedStore(val) {
      this.selectedTerminal = null
      if(!val){
        this.terminalData = []
        return
      }
      this.getTerminalData()
    },
    selectedTerminal(val) {
      this.selectedChannel = null
      if(!val){
        this.channelData = []
        return
      }
      this.getChannelData()
    },
  }
};
</script>
